import * as React from 'react';
import { SVGProps } from 'react';

const IconPauseSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 4H5v16h5V4zm9 0h-5v16h5V4z" />
  </svg>
);
export default IconPauseSizeM;
